export const enrollmentActions = {
  fetchPickupWeeks: () => ({
    type: 'pickupWeeks.fetch',
  }),
  fetchPickupWeeksSuccess: (payload) => ({
    type: 'pickupWeeks.success',
    payload,
  }),
  fetchPickupWeeksFailure: () => ({
    type: 'pickupWeeks.failure',
  }),

  fetchStoredState: () => ({
    type: 'storedState.fetch',
  }),
  fetchStoredStateSuccess: (payload) => ({
    type: 'storedState.fetch.success',
    payload,
  }),
  fetchStoredStateFailure: () => ({
    type: 'storedState.fetch.failure',
  }),

  resetStoredState: () => ({
    type: 'storedState.reset',
  }),
  resetStoredStateSuccess: () => ({
    type: 'storedState.reset.success',
  }),
  resetStoredStateFailure: () => ({
    type: 'storedState.reset.failure',
  }),

  saveStoredState: (payload) => ({
    type: 'storedState.save',
    payload,
  }),
  saveStoredStateSuccess: (payload) => ({
    type: 'storedState.save.success',
    payload,
  }),
  saveStoredStateFailure: () => ({
    type: 'storedState.save.failure',
  }),

  saveEnrolment: (payload) => ({
    type: 'enrolment.save',
    payload,
  }),
  saveEnrolmentSuccess: (payload) => ({
    type: 'enrolment.save.success',
    payload,
  }),
  saveEnrolmentFailure: (payload) => ({
    type: 'enrolment.save.failure',
    payload,
  }),

  deleteRegisteredEnrolment: (payload) => ({
    type: 'enrolment.deleteSave',
    payload,
  }),
  deleteRegisteredEnrolmentSuccess: (payload) => ({
    type: 'enrolment.deleteSave.success',
    payload,
  }),
  deleteRegisteredEnrolmentFailure: (payload) => ({
    type: 'enrolment.deleteSave.failure',
    payload,
  }),

  fetchRegisteredEnrolment: (payload) => ({
    type: 'enrolment.registered.fetch',
    payload,
  }),
  fetchRegisteredEnrolmentSuccess: (payload) => ({
    type: 'enrolment.fetch.registered.success',
    payload,
  }),
  fetchRegisteredEnrolmentFailure: (payload) => ({
    type: 'enrolment.fetch.registered.failure',
    payload,
  }),

  fetchRegisteredEnrolmentDates: (payload) => ({
    type: 'enrolment.dates.registered.fetch',
    payload,
  }),
  fetchRegisteredEnrolmentDatesSuccess: (payload) => ({
    type: 'enrolment.dates.fetch.registered.success',
    payload,
  }),
  fetchRegisteredEnrolmentDatesFailure: (payload) => ({
    type: 'enrolment.dates.fetch.registered.failure',
    payload,
  }),

  fetchReturnForms: payload => ({
    type: 'enrolment.returnForms.fetch',
    payload,
  }),
  fetchReturnFormsSuccess: payload => ({
    type: 'enrolment.returnForms.fetch.success',
    payload,
  }),
  fetchReturnFormsFailure: payload => ({
    type: 'enrolment.returnForms.fetch.registered.failure',
    payload,
  }),

  resetEnrolmentDates: () => ({
    type: 'enrolment.dates.reset',
  }),
};
